export default __webpack_public_path__ + "static/media/Manual_Marca.b176b9f1.pdf";